module.exports = __webpack_public_path__ + "img/replicate-treatment-icon.63bdae4b.svg";